import Vue from 'vue';
import store from '@/plugin/store';
import i18n from '@/plugin/i18n';
import '@/plugin/swal';
import XLSX from 'xlsx';
// import {eventBus} from "@/script/global-emit/eventBus";

let baseUrl = window.baseUrl || process.env.VUE_APP_BASE_URL || '';

export const swalConfirm = Vue.swal.mixin({
    title: i18n.t('Please_Confirm'),
    text: i18n.t('Delete_Confirmation_Question'),
    icon: 'warning',
    confirmButtonColor: '#1E88E5',
    confirmButtonText: `<div 
                            style='display: flex; align-items: center'
                        >
                            <i 
                                class='material-icons'
                                style='margin-right: 8px;'
                            >
                                delete
                            </i>
                            ${i18n.t('Yes')}
                        </div>`,
    showLoaderOnConfirm: true,

    showCancelButton: true,
    cancelButtonColor: '#fff',
    cancelButtonText: `<div
                            style='color: #1E88E5'
                        >
                            ${i18n.t('Cancel')}
                        </div>`,
    allowOutsideClick: false,
    allowEnterKey: false
});

export const swalPrompt = Vue.swal.mixin({
    text: i18n.t('Please_Enter'),
    icon: 'warning',

    input: 'textarea',
    inputAttributes: {
        autocapitalize: 'off'
    },

    confirmButtonColor: '#1E88E5',
    confirmButtonText: `<div 
                            style='display: flex; align-items: center;'
                        >
                            <i 
                                class='material-icons'
                                style='margin-right: 8px;'
                            >
                                send
                            </i>
                            ${i18n.t('Send')}
                        </div>`,
    showLoaderOnConfirm: true,

    showCancelButton: true,
    cancelButtonColor: '#fff',
    cancelButtonText: `<div
                            style='color: #1E88E5'
                        >
                            ${i18n.t('Cancel')}
                        </div>`,

    allowOutsideClick: false,
    allowEnterKey: false
});

export const swalPromptPassword = Vue.swal.mixin({
    text: `${i18n.t('Please_Enter_Password')}`,
    icon: 'warning',

    input: 'password',
    inputAttributes: {
        autocapitalize: 'off'
    },

    confirmButtonColor: '#1E88E5',
    confirmButtonText: `<div 
                            style='display: flex; align-items: center;'
                        >
                            <i 
                                class='material-icons'
                                style='margin-right: 8px;'
                            >
                                send
                            </i>
                            ${i18n.t('Send')}
                        </div>`,
    showLoaderOnConfirm: true,

    showCancelButton: true,
    cancelButtonColor: '#fff',
    cancelButtonText: `<div
                            style='color: #1E88E5'
                        >
                            ${i18n.t('Cancel')}
                        </div>`,

    allowOutsideClick: false,
    allowEnterKey: false
});

export function blockUI(message = null) {
    store.dispatch('BlockUI', message);
}
export function unblockUI() {
    store.dispatch('UnblockUI');
}

export function parseDatetime(datetime) {
    let formats = [
        {
            regex: /^(\d{4})-(\d{2})-(\d{2})$/,
            parse: m => new Date(+m[1], +m[2] - 1, +m[3])
        },
        {
            regex: /^(\d{4})-(\d{2})-(\d{2})(?: |T)(\d{2}):(\d{2})$/,
            parse: m => new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5])
        },
        {
            regex: /^(\d{4})-(\d{2})-(\d{2})(?: |T)(\d{2}):(\d{2}):(\d{2})$/,
            parse: m => new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6])
        },
        {
            regex: /^(\d{2})\/(\d{2})\/(\d{4})$/,
            parse: m => new Date(+m[3], +m[2] - 1, +m[1])
        },
        {
            regex: /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/,
            parse: m => new Date(+m[3], +m[2] - 1, +m[1], +m[4], +m[5])
        },
        {
            regex: /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/,
            parse: m => new Date(+m[3], +m[2] - 1, +m[1], +m[4], +m[5], +m[6])
        },
    ];
    for (let i = 0; i < formats.length; i++) {
        const format = formats[i];
        if (format.regex.test(datetime)) {
            return format.parse(format.regex.exec(datetime));
        }
    }
    return null;
}
export function getDateStr(date, options) {
    if (!options) {
        options = {};
    }
    if (!options.format) {
        options.format = 'dd/MM/yyyy';
    }
    return getDateTimeStr(date, options);
}
export function getTimeStr(date, options) {
    if (!options) {
        options = {};
    }
    if (!options.format) {
        options.format = 'HH:mm';
    }
    return getDateTimeStr(date, options);
}
export function getDateTimeStr(date, options) {
    if (date === null) return null;
    if (!options) {
        options = {};
    }
    if (!options.format) {
        options.format = 'dd/MM/yyyy HH:mm';
    }

    var shouldAddTimezone = false;

    if (typeof date === 'string') {
        let tempDate = parseDatetime(date);
        if (tempDate) {
            date = tempDate;
        } else {
            date = date.replace(/(-|T)/g, '/');
        }
        shouldAddTimezone = true;
    }

    if (!(date instanceof Date)) {
        date = new Date(date);
    }

    if (date === 'Invalid Date') return;

    if (shouldAddTimezone && !options.withoutTimezone) {
        let tzOffset = -new Date().getTimezoneOffset() / 60;
        date.setHours(date.getHours() + tzOffset);
    }

    var days = ('0' + date.getDate()).slice(-2),
        month = ('0' + (date.getMonth() + 1)).slice(-2),
        year = date.getFullYear(),
        hours = ('0' + date.getHours()).slice(-2),
        minutes = ('0' + date.getMinutes()).slice(-2),
        seconds = ('0' + date.getSeconds()).slice(-2);

    return options.format
        .replace('dd', days)
        .replace('MM', month)
        .replace('yyyy', year)
        .replace('hh', hours)
        .replace('HH', hours)
        .replace('mm', minutes)
        .replace('ss', seconds);
}

export function nullableToFixed(param, decimals) {
    if (!param) return 0;
    return param.toFixed(decimals);
}

export function groupHasPermission(permissionId) {
    return true;
}

export function saveAsExcel(data, titles) {
    if (!titles || typeof titles != 'object') {
        titles = {
            workbookTitle: 'Result',
            workSheetTitle: 'Result'
        };
    }
    if (!titles.workbookTitle) {
        titles.workbookTitle = 'Result';
    }
    if (!titles.workSheetTitle) {
        titles.workSheetTitle = 'Result';
    }
    var wb = XLSX.utils.book_new(),
        ws = XLSX.utils.json_to_sheet(data);

    XLSX.utils.book_append_sheet(wb, ws, titles.workSheetTitle);
    XLSX.writeFile(wb, titles.workbookTitle + '.xlsx');
}

export function saveExcelTemplate({ headers, titles, widths }) {
    if (!titles || typeof titles != 'object') {
        titles = {
            workbookTitle: 'Template',
            workSheetTitle: 'Template'
        };
    }
    if (!titles.workbookTitle) {
        titles.workbookTitle = 'Template';
    }
    if (!titles.workSheetTitle) {
        titles.workSheetTitle = 'Template';
    }

    var wb = XLSX.utils.book_new(),
        ws = XLSX.utils.aoa_to_sheet([headers]);

    if (widths) {
        widths.reduce((a, v) => ({ ...a, [v]: v }), {});
        var wsCols = [];
        for (let i = 0; i < widths.length; i++) {
            wsCols.push({ wch: widths[i] });
        }
        ws['!cols'] = wsCols;
    }

    XLSX.utils.book_append_sheet(wb, ws, titles.workSheetTitle);
    XLSX.writeFile(wb, titles.workbookTitle + '.xlsx');
}

export function saveExcelFile(data, filename, sheetname) {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetname);
    XLSX.writeFile(wb, `${filename}.xlsx`);
}

export function fetchBasicGet(url, fetchHandlerSettings) {
    return fetch(baseUrl + url, defaultFetchOptions())
        .fetchAuthRedirectChecker()
        .fetchResponseHandler(fetchHandlerSettings)
        .fetchBasicCatchHandle();
}
export function fetchGetJson(url, settings, fetchHandlerSettings) {
    return fetch(baseUrl + url, fetchUrlGetOptions(settings))
        .fetchAuthRedirectChecker()
        .fetchJsonResponseHandler(fetchHandlerSettings);
}
export function fetchBasicGetJson(url, settings, fetchHandlerSettings) {
    return fetchGetJson(url, settings, fetchHandlerSettings)
        .fetchBasicCatchHandle();
}
export function fetchUrlGet(url, settings) {
    return fetch(
        baseUrl + url + '?' + new URLSearchParams(settings.data).toString(),
        fetchUrlGetOptions(settings)
    ).fetchAuthRedirectChecker();
}
export function fetchJsonGet(url, settings) {
    return fetch(baseUrl + url, fetchJsonGetOptions(settings))
        .fetchAuthRedirectChecker();
}
export function fetchUrlPost(url, settings) {
    return fetch(baseUrl + url, fetchUrlPostOptions(settings))
        .fetchAuthRedirectChecker();
}
export function fetchJsonPost(url, settings) {
    return fetch(baseUrl + url, fetchJsonPostOptions(settings))
        .fetchAuthRedirectChecker();
}
export function fetchBasicUrlGet(url, settings, fetchHandlerSettings) {
    return fetchUrlGet(url, settings)
        .fetchResponseHandler(fetchHandlerSettings)
        .fetchBasicCatchHandle();
}
export function fetchBasicUrlGetJson(url, settings, fetchHandlerSettings) {
    return fetchUrlGet(url, settings)
        .fetchJsonResponseHandler(fetchHandlerSettings)
        .fetchBasicCatchHandle();
}
export function fetchJsonGetJson(url, settings, fetchHandlerSettings) {
    return fetchJsonGet(url, settings)
        .fetchJsonResponseHandler(fetchHandlerSettings);
}
export function fetchBasicJsonGetJson(url, settings, fetchHandlerSettings) {
    return fetchJsonGetJson(url, settings, fetchHandlerSettings)
        .fetchBasicCatchHandle();
}
export function fetchBasicUrlPost(url, settings, fetchHandlerSettings) {
    return fetchUrlPost(url, settings)
        .fetchResponseHandler(fetchHandlerSettings)
        .fetchBasicCatchHandle();
}
export function fetchBasicUrlPostJson(url, settings, fetchHandlerSettings) {
    return fetchUrlPost(url, settings)
        .fetchJsonResponseHandler(fetchHandlerSettings)
        .fetchBasicCatchHandle();
}
export function fetchBasicJsonPost(url, settings, fetchHandlerSettings) {
    return fetchJsonPost(url, settings)
        .fetchResponseHandler(fetchHandlerSettings)
        .fetchBasicCatchHandle();
}
export function fetchBasicJsonPostText(url, settings, fetchHandlerSettings) {
    return fetchJsonPost(url, settings)
        .fetchTextResponseHandler(fetchHandlerSettings)
        .fetchBasicCatchHandle();
}
export function fetchBasicJsonPostJson(url, settings, fetchHandlerSettings) {
    return fetchJsonPost(url, settings)
        .fetchJsonResponseHandler(fetchHandlerSettings)
        .fetchBasicCatchHandle();
}
function defaultFetchOptions() {
    var headers = new Headers();
    headers.append('Accept', 'application/json');
    let result = { headers: headers };
    if (baseUrl) {
        result.credentials = 'include';
    }
    return result;
}
function fetchJsonGetOptions(settings) {
    var options = fetchJsonOptions(settings);
    options.method = 'GET';
    return options;
}
function fetchJsonPostOptions(settings) {
    var options = fetchJsonOptions(settings);
    options.method = 'POST';
    return options;
}
function fetchJsonOptions(settings) {
    var options = defaultFetchOptions();
    options.headers.append('Content-Type', 'application/json');
    if (settings && settings.asGridData) {
        options.headers.append('Custom-Source', 'datatable');
        settings.data = GridDataParameters(settings.data);
    }
    if (settings && settings.asGridDataPage) {
        options.headers.append('Custom-Source', 'datatable');
        settings.data = GridDataPageParameters(settings.data);
    }
    options.body =
        settings && settings.data ? JSON.stringify(settings.data) : null;
    options.signal = settings ? settings.signal : null;
    if (settings && settings.headers) {
        Object.keys(settings.headers).forEach(key => {
            options.headers.append(key, encodeURIComponent(settings.headers[key]));
        });
    }
    return options;
}
function fetchUrlGetOptions(settings) {
    var options = defaultFetchOptions();
    options.method = 'GET';
    options.signal = settings ? settings.signal : null;
    if (settings && settings.headers) {
        Object.keys(settings.headers).forEach(key => {
            options.headers.append(key, encodeURIComponent(settings.headers[key]));
        });
    }
    return options;
}
function fetchUrlPostOptions(settings) {
    var options = defaultFetchOptions();
    options.headers.append(
        'Content-Type',
        'application/x-www-form-urlencoded; charset=UTF-8'
    );
    if (settings && settings.asGridData) {
        options.headers.append('Custom-Source', 'datatable');
        settings.data = GridDataParameters(settings.data);
    } else if (settings && settings.asGridDataPage) {
        options.headers.append('Custom-Source', 'datatable');
        settings.data = GridDataPageParameters(settings.data);
    }
    options.method = 'POST';
    options.body =
        settings && settings.data
            ? URLSearchParamsToString(settings.data)
            : null;
    options.signal = settings ? settings.signal : null;
    if (settings && settings.headers) {
        Object.keys(settings.headers).forEach(key => {
            options.headers.append(key, encodeURIComponent(settings.headers[key]));
        });
    }
    return options;
}
function URLSearchParamsToString(data) {
    Object.keys(data).forEach(item => {
        if (data[item] === null || data[item] === '') delete data[item]
    })
    return new URLSearchParams(data).toString()
}
function initialFetchHandlerSettings(settings) {
    settings = settings || {};
    if (settings.useBlock !== false) {
        settings.useBlock = true;
    }
    return settings;
}
Promise.prototype.fetchAuthRedirectChecker = function () {
    var _this = this;
    return new Promise(function (resolve, reject) {
        _this.then(function (response) {
            if (
                response
                && response.url
                && /^https?:\/\/[^/]+\/signIn/.test(response.url)
            ) {
                if (location.pathname == '/signIn') {
                    reject({ aborted: true });
                    return;
                }
                let match = /^(https?:\/\/[^/]+)\/signIn/.exec(response.url);
                let returnUrl =
                    match[1] == location.origin
                        ? location.pathname + location.search + location.hash
                        : '';
                let search = returnUrl ? `?returnUrl=${encodeURI(returnUrl)}` : '';
                // location.assign(match[0] + search);
                location.assign("/signIn" + search);
                // eventBus.$emit("status401")
            } else {
                resolve(response);
            }
        }).catch(reject);
    });
};
Promise.prototype.fetchBasicCatchHandle = function () {
    var _this = this;
    return new Promise(function (resolve, reject) {
        _this.then(resolve).catch(function (reason) {
            if (reason && reason.InvalidThirdPartyPassword === true) {
                reject(reason);
                return;
            }
            if (
                reason.response
                && reason.response.headers
                && reason.response.headers.get('ErrorCode')
                && reason.response.headers.get('ErrorCode') !== 'NoError'
            ) {
                let errorCode = reason.response.headers.get('ErrorCode');
                let errorCodeLocaleKey = 'ErrorCode_' + errorCode;
                let errorDescription = i18n.t(errorCodeLocaleKey);
                if (errorDescription != errorCodeLocaleKey) {
                    let errorCustomData = reason.response.headers.get('ErrorCustomData');
                    try {
                        if (errorCustomData) {
                            errorCustomData = JSON.parse(errorCustomData);
                        }
                        if (errorCustomData && Object.keys(errorCustomData)) {
                            Object.keys(errorCustomData).forEach(key => {
                                errorDescription = errorDescription.replaceAll(`{${key}}`, errorCustomData[key]);
                            });
                        }
                    } catch { }
                    blockUI(`${i18n.t('Error_Occurred')}: ${errorCode} - ${errorDescription}`);
                } else if (reason && reason.message) {
                    blockUI(`${i18n.t('Error_Occurred')}: ${errorCode} - ${reason.message}`);
                } else {
                    blockUI(`${i18n.t('Error_Occurred')}: ${errorCode}`);
                }
            } else if (!reason || !reason.aborted) {
                blockUI(
                    reason && reason.message
                        ? reason.message
                        : reason || i18n.t('Error_Occurred')
                );
            }
            reject(reason);
        });
    });
};
Promise.prototype.fetchResponseHandler = function (settings) {
    var _this = this;
    settings = initialFetchHandlerSettings(settings);
    if (settings.useBlock) {
        blockUI();
    }
    return new Promise(function (resolve, reject) {
        _this
            .then(function (response) {
                if (response.ok) {
                    resolve(response);
                } else if (response.status === 401) {
                    // eventBus.$emit("status401")
                    setOnAuth(personCode => { console.log("x:", response) })
                } else if (response.status === 500) {
                    if (
                        settings
                        && settings.customThirdPartyPasswordError === true
                        && response
                        && response.headers
                        && response.headers.get('ErrorCode') === 'InvalidThirdPartyPassword'
                    ) {
                        reject({
                            response,
                            InvalidThirdPartyPassword: true
                        });
                        return Promise.resolve();
                    }
                    if (settings.useBlock) {
                        blockUI();
                    }
                    response
                        .text()
                        .then(function (text) {
                            reject({
                                message: text,
                                response: response
                            });
                        })
                        .catch(function (resp) {
                            reject({
                                message:
                                    'Request failed. Can not read message. Status ' +
                                    response.status +
                                    ' ' +
                                    response.statusText +
                                    '.',
                                status: response.status,
                                response: resp
                            });
                        })
                        .then(function () {
                            if (settings.useBlock) {
                                unblockUI();
                            }
                        });
                } else {
                    reject({
                        message:
                            'Request failed. Status ' +
                            response.status +
                            ' ' +
                            response.statusText +
                            '.',
                        status: response.status,
                        response: response
                    });
                }
            })
            .catch(function (error) {
                if (error && error.name === 'AbortError') {
                    return reject({
                        aborted: true,
                        message: 'Request aborted.',
                        response: error
                    });
                } else {
                    reject({
                        message: 'Request failed.',
                        response: error
                    });
                }
            })
            .then(function () {
                if (settings.useBlock) {
                    unblockUI();
                }
            });
    });
};
Promise.prototype.fetchTextResponseHandler = function (settings) {
    var _this = this;
    settings = initialFetchHandlerSettings(settings);
    return new Promise(function (resolve, reject) {
        _this
            .fetchResponseHandler(settings)
            .then(function (response) {
                if (settings.useBlock) {
                    blockUI();
                }
                response
                    .text()
                    .then(resolve)
                    .catch(function (resp) {
                        reject({
                            message: 'Can not convert to Text.',
                            status: response.status,
                            isTextCatch: true,
                            response: resp
                        });
                    })
                    .then(function () {
                        if (settings.useBlock) {
                            unblockUI();
                        }
                    });
            })
            .catch(reject);
    });
};
Promise.prototype.fetchCommonResponseHandler = function (settings) {
    if (!settings || !settings.commonResponse) {
        return this; // No common response handling needed
    }
    let _promise = this;
    return new Promise(function (resolve, reject) {
        _promise
            .then(function (response) {
                if (response) {
                    if (response.hasError) {
                        reject({
                            message: `[${response.error}] ${response.message}`,
                            isCommonResponse: true,
                            response
                        });
                    } else {
                        resolve(response.data);
                    }
                } else {
                    resolve(null);
                }
            });
    });
};
Promise.prototype.fetchJsonResponseHandler = function (settings) {
    var _this = this;
    settings = initialFetchHandlerSettings(settings);
    return new Promise(function (resolve, reject) {
        _this
            .fetchResponseHandler(settings)
            .then(function (response) {
                if (response.status === 204) {
                    resolve(null);
                    return;
                }
                if (settings.useBlock) {
                    blockUI();
                }
                response
                    .json()
                    .fetchCommonResponseHandler(settings)
                    .then(resolve)
                    .catch(function (resp) {
                        if (resp && resp.isCommonResponse) {
                            reject(resp);
                        } else {
                            reject({
                                message: 'Can not convert to JSON.',
                                status: response.status,
                                isJsonCatch: true,
                                response: resp
                            });
                        }
                    })
                    .catch(function (message, resp) {
                        reject({
                            message: message,
                            status: response.status,
                            isJsonCatch: true,
                            response: resp
                        });
                    })
                    .then(function () {
                        if (settings.useBlock) {
                            unblockUI();
                        }
                    });
            })
            .catch(reject);
    });
};

function GridDataPageParameters(parameters) {
    if (parameters.page > 0 && parameters.pageSize > 0) {
        parameters.start = (parameters.page - 1) * parameters.pageSize;
        parameters.length = parameters.pageSize;
        delete parameters.page;
        delete parameters.pageSize;
    }
    parameters['draw'] = 1;
    parameters['columns[0][data]'] = ' ';
    parameters['columns[0][name]'] = ' ';
    parameters['columns[0][searchable]'] = ' ';
    parameters['columns[0][orderable]'] = ' ';
    parameters['columns[0][search][value]'] = ' ';
    parameters['columns[0][search][regex]'] = ' ';
    return parameters;
}

function GridDataParameters(parameters) {
    parameters = GridDataPageParameters(parameters);
    let keys = Object.keys(parameters).filter(
        k =>
            k != 'draw' &&
            k != 'start' &&
            k != 'length' &&
            !k.startsWith('columns[') &&
            !k.startsWith('search[') &&
            !k.startsWith('filter[')
    );
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (parameters[key] !== null) {
            let items = GridDataParametersFilter(parameters[key], `filter[${key}]`);
            parameters = {
                ...parameters,
                ...items.reduce((t, c) => ({ ...t, [c.key]: c.value }), {})
            };
        }
        delete parameters[key];
    }
    return parameters;
}

function GridDataParametersFilter(item, prefix) {
    if (typeof (item) == typeof ({})) {
        let keys = Object.keys(item);
        let result = [];
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (item[key] !== null) {
                let subItems = GridDataParametersFilter(item[key], `${prefix}[${key}]`);
                result = result.concat(subItems);
            }
        }
        return result;
    }
    return [
        {
            key: prefix,
            value: item
        }
    ];
}

export function groupBy(data, property) {
    var grouped = {};
    for (var i = 0; i < data.length; i++) {
        if (!grouped[data[i][property]]) {
            grouped[data[i][property]] = [data[i]];
        } else {
            grouped[data[i][property]].push(data[i]);
        }
    }
    return grouped;
}

export function asyncForeach(items, itemProcess) {
    return items.length === 0
        ? Promise.resolve()
        : itemProcess(items.shift())
            .then(() => asyncForeach(items, itemProcess));
}

export function asyncForeachProgress(items, itemProcess, progress) {
    let counter = 0, total = items.length;
    return asyncForeach(
        items,
        item => itemProcess(item).then(() => progress ? progress(++counter, total) : null)
    );
}

export function asyncForeachPacket(items, packetSize, itemProcess, progress) {
    let packets = [];
    for (let i = 0; i < items.length; i += packetSize) {
        packets.push(items.slice(i, i + packetSize));
    }
    return asyncForeachProgress(packets, itemProcess, progress);
}

function setOnAuth(method) {
    store.state.onAuth.push(method)
}

export function calculateAgeString(fromDate, toDate) {
    let age = calculateAge(fromDate, toDate);
    if (age.years < 0 || age.months < 0 || age.days < 0) {
        return '';
    } else if (age.years < 1) {
        return `${age.months} ${i18n.t('Age_Suffixes.Months')} ${age.days} ${i18n.t('Age_Suffixes.Days')}`;
    } else if (age.years < 5) {
        return `${age.years} ${i18n.t('Age_Suffixes.Years')} ${age.months} ${i18n.t('Age_Suffixes.Months')}`;
    } else {
        return `${age.years} ${i18n.t('Age_Suffixes.Years')}`;
    }
}
export function calculateAge(fromDate, toDate) {
    if (toDate) toDate = new Date(toDate);
    else toDate = new Date();

    fromDate = new Date(fromDate);
    let ydiff = toDate.getFullYear() - fromDate.getFullYear();
    let m = [toDate.getMonth(), fromDate.getMonth()];
    let mdiff = m[0] - m[1];
    let d = [toDate.getDate(), fromDate.getDate()];
    let ddiff = d[0] - d[1];

    if (mdiff < 0 || (mdiff === 0 && ddiff < 0)) --ydiff;
    if (mdiff < 0) mdiff += 12;
    if (ddiff < 0) {
        fromDate.setMonth(m[1] + 1, 0);
        ddiff = fromDate.getDate() - d[1] + d[0];
        mdiff = mdiff ? mdiff - 1 : 11;
    }
    return {
        years: ydiff,
        months: mdiff,
        days: ddiff
    };
}

export async function handleCommonResponse(promise) {
    let response = await promise;
    if (response) {
        if (response.hasError) {
            throw `[${response.error}] ${response.message}`;
        }
        return response.data;
    }
    return null;
}